'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _input = require('../../BaseInput/styled/input');

var _input2 = _interopRequireDefault(_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _styledComponents2.default)(_input2.default).withConfig({
  componentId: 'kxxwi2-0'
})(['color:#000;padding-left:0;padding-right:0;margin-left:0;margin-right:0;&:focus{box-shadow:none;}&::-webkit-slider-thumb,&::-moz-range-thumb,&::-ms-thumb{&:focus{box-shadow:0 0 2px 3px ', ';}}'], function (p) {
  return p.theme.focusColor;
});